<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" class="scaling-svg">
      <g transform="translate(-0.308 0)">
        <path d="M18.5,0A18.5,18.5,0,1,1,0,18.5,18.5,18.5,0,0,1,18.5,0Z" transform="translate(0.308 0)" fill="#fff" />
        <path
          d="M0,4.723,5.139,9.862,14.119,0"
          transform="translate(11.49 14.07)"
          fill="none"
          stroke="#00caa8"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DialogSuccessIcon extends Vue {}
</script>

<style></style>
